import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-detail-general-reporting-client',
  templateUrl: './detail-general-reporting-client.component.html',
  styleUrls: ['./detail-general-reporting-client.component.css']
})
export class DetailGeneralReportingClientComponent implements OnInit {
  // Fiches Recues -- Valeur En nombre
  FicheRecues: number = 0;
  // Fiche Traitées -- Valeur En nombre
  FicheTraitees: number = 0;
  // MaturitéMoyInitiales/retour -- Valeur En minute
  dureeMoyenneTraitement: number = 0;
  // Graphe PIE CHART
  dataGraphePieGeneral: any;
  // Nombre Total de fiches KO
  NombreTotalFicheKO: number = 0;

  constructor() { }

  ngOnInit(): void {
  }

}
